<template>
    <Tooltip :content="$tr('userProfile.logout')">
        <button
            :disabled="disabledLogout"
            :class="$style.logout_button"
            data-interface-target="logout"
            @click.stop.prevent="logout"
        >
            <Icon
                name="logout"
                :class="[$style.logout_icon, disabledLogout && $style.disabled]"
            />
        </button>
    </Tooltip>
</template>
<script lang="ts" setup>
import { ref } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import Tooltip from '@/components_new/Tooltip.vue'

const disabledLogout = ref(false)
const emit = defineEmits<{ logout: [] }>()

function logout() {
    if (disabledLogout.value) {
        return
    }
    disabledLogout.value = true

    emit('logout')
}
</script>
<style module>
.logout_button {
    height: 52px;
    width: 52px;
    background-color: var(--carbon-400);
    border-radius: 50%;
    cursor: pointer;
}

.logout_icon {
    width: 24px;
    height: 24px;
    color: var(--white);
}

.logout_button:hover,
.logout_button:focus {
    border: 0.5px solid #935a5a;
    background: var(--carbon-300);
    box-shadow: 0px 0px 30px 0px rgba(244, 90, 90, 0.64) inset;
}

.disabled {
    color: rgba(255, 255, 255, 0.4);
    cursor: not-allowed;
}
</style>
